var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticStyle:{"font-weight":"bold","padding-bottom":"15px"},attrs:{"id":"study-complete-heading"}},[_vm._v(" DeepAngio Research Study Complete ")]),_c('p',[_vm._v(" Thank you for taking part in the DeepAngio research study. You may close this tab. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }